import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import AlbumDesign from "../../Components/services/album-editing/AlbumDesign";
import AlbumEditingFaqs from "../../Components/services/album-editing/AlbumEditingFaqs";
import AlbumDesign2 from "../../Components/services/album-editing/AlbumDesign2";

const AlbumEditing = () => {
  return (
    <>
      <Navbar />
      <div
        className="bg_maincolor d-flex align-items-center justify-content-center"
        style={{ height: "14rem" }}
      >
        <h1 className="display-6 prata-regular fw-bold text-center text-light ">
          Album Design Services
        </h1>
      </div>
      <div className="mx-5 my-5 py-5">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div
              id="carouselClassicModern"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active" data-bs-interval="2000">
                  <img
                    src="/images/Album S1.jpg"
                    className="d-block w-100 object-fit-cover"
                    style={{ height: "400px" }}
                    alt="Classic Album"
                  />
                </div>
                <div className="carousel-item" data-bs-interval="2000">
                  <img
                    src="/images/Album S2.jpg"
                    className="d-block w-100 object-fit-cover"
                    style={{ height: "400px" }}
                    alt="Modern Album"
                  />
                </div>
                <div className="carousel-item" data-bs-interval="2000">
                  <img
                    src="/images/Album S3.jpg"
                    className="d-block w-100 object-fit-cover"
                    style={{ height: "400px" }}
                    alt="Modern Album 2"
                  />
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselClassicModern"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselClassicModern"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className="col-md-6 ps-5">
            <h2 className="prata-regular mb-4"> Album Design</h2>
            <p>
              Are you are looking for trusted Album Designing
              Service?captureEdits is a one stop solution for all your
              photography post production needs.A few examples of our work. For
              a larger display, We work according to your requirements and are
              looking forward to your reference Design.Send us your pictures and
              we shall design creative album layouts unique to your photos.We do
              not use any readymade templates for designing albums to ensure
              your albums speak your story.
            </p>
            <p>
              We are a Wedding Album Design Company that serves as a backbone
              for professional wedding and portrait photographers for wedding
              album design & wedding photo album book needs With a strong team
              of creative designers, our uniqueness lies in helping you bring
              out your work by converting albums into their bonding story. With
              our customized designing to match up to your customers’
              expectations.
            </p>
            <p>
              Not Just Weddings! We specialize in customized layout designing
              for Weddings, Birthdays, Anniversaries, Holidays and other events.
              Besides, we also design albums and photos books for seniors, New
              Born, Maternity shoots. Bar Mitzvahs, portraits, boudoirs, parties
              and etc.
            </p>{" "}
            <p>
              We are expert in providing finest quality wedding album design
              services at affordable pricing.
            </p>
          </div>
        </div>
      </div>
      <AlbumDesign2 />
      <AlbumDesign />
      <AlbumEditingFaqs />
      <Footer />
    </>
  );
};

export default AlbumEditing;
